import React, {useEffect, useState} from 'react';
import './AuditComponent.css'
import {Button, Card, Col, Form, Row} from 'react-bootstrap';
import Loader from '../../components/Loader';
import {Actions} from "../../../client/Actions";
import {paramsSerializer} from "../../helpers/jwt";
import dateUtils from "../../helpers/dateUtils";
import { useTranslation } from 'react-i18next';

const AuditSearchForm = ({apiType, storeSetter}) => {
    const { t } = useTranslation();
    // loader
    const [loader, setLoader] = useState(false);

    const [isFormValidated, setIsFormValidated] = useState(false);

    const [dateToValue, setDateToValue] = useState('');
    const [dateFromValue, setDateFromValue] = useState(() => {
        const date = new Date();
        date.setDate(date.getDate() - 30);

        // Format the date as yyyy-MM-dd
        return date.toISOString().split('T')[0];
    });

    const handleSearchRequest = (e) => {
        e.preventDefault();
        prepareRequest();
    };

    const dataLoaded = (data) => {
        setLoader(false)
        storeSetter(data)
    };

    const prepareRequest = () => {
        setLoader(true)
        Actions.get(`/audit/${apiType}?${paramsSerializer({from: dateFromValue, to: dateToValue})}`, dataLoaded)
    };

    useEffect(prepareRequest, []);

    return (
        <>
            <Loader loader={loader} setLoader={setLoader}/>
            <Card className="mt-2">
                <Card.Header className="py-3">{t("forms.search_by_dates")}</Card.Header>
                <Card.Body>
                    <Form noValidate className={!isFormValidated ? "form-valid-animation" : "form-invalid-animation"}
                          onSubmit={handleSearchRequest}>
                        <Row>
                            <Col sm="5">
                                <Form.Group as={Row} controlId="delivery_date_control">
                                    <Form.Label column sm="3" className="text-right mt-1"><strong>{t("forms.date_from")}</strong></Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            // className={deliveryDateError ? "is-invalid" : "is-valid"}
                                            onChange={e => setDateFromValue(e.target.value)}
                                            name="delivery_date"
                                            value={dateFromValue}
                                            type="date"

                                            loca
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm="5">
                                <Form.Group as={Row} controlId="delivery_date_control">
                                    <Form.Label column sm="3" className="text-right mt-1 "><strong>{t("forms.date_to")}</strong></Form.Label>
                                    <Col sm="9">
                                        <Form.Control
                                            onChange={e => setDateToValue(e.target.value)}
                                            name="delivery_date"
                                            value={dateToValue}
                                            type="date"
                                        />
                                    </Col>
                                </Form.Group>
                            </Col>
                            <Col sm="2">
                                <Button type="submit" variant="primary">{t("common.refresh")}</Button>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
        </>
    );
}

export default AuditSearchForm;
